import React, { useState, useEffect } from 'react';
import { familiesAPI } from '../../../services/api';
import toast from 'react-hot-toast';

const CreateFamilyModal = ({ show, onClose, householdId, residents, onFamilyCreated }) => {
  const [headOfFamilyId, setHeadOfFamilyId] = useState('');
  const [familyName, setFamilyName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!show) {
      setHeadOfFamilyId('');
      setFamilyName('');
      setIsSubmitting(false);
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!headOfFamilyId) {
      toast.error('Please select a head of family');
      return;
    }
    setIsSubmitting(true);
    try {
      const res = await familiesAPI.create({
        household_id: householdId,
        head_of_family_id: headOfFamilyId,
        family_name: familyName
      });
      toast.success('Family created successfully');
      if (onFamilyCreated) onFamilyCreated(res.data.data);
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to create family');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-bold mb-4">Create Family</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-1 font-medium">Head of Family</label>
            <select
              className="w-full border rounded px-3 py-2"
              value={headOfFamilyId}
              onChange={e => setHeadOfFamilyId(e.target.value)}
              required
            >
              <option value="">Select resident</option>
              {residents?.map(r => (
                <option key={r.id} value={r.id}>
                  {r.first_name} {r.last_name}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block mb-1 font-medium">Family Name (optional)</label>
            <input
              className="w-full border rounded px-3 py-2"
              value={familyName}
              onChange={e => setFamilyName(e.target.value)}
              placeholder="e.g. Dela Cruz Family"
            />
          </div>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="px-4 py-2 bg-gray-200 rounded"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Creating...' : 'Create Family'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateFamilyModal;
